import angular from 'angular';

import LinkDashboardController from './link-api.controller';

import './link-api.styles.scss';

export default angular.module('autoboard.linkEntryDashboard', [])
  .controller('LinkDashboardController', LinkDashboardController)
  .name;
